<div class="container-fluid" *ngIf="!loading">
  <div class="row" *ngIf="showTitle">
    <div class="col">
      <h3>
        {{ departmentId === 'add' ? 'New Department' : 'Edit Department' }}
      </h3>
    </div>
  </div>

  <form [formGroup]="form" *ngIf="form">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="name"
            >Department Name <span class="text-danger">*</span></label
          >
          <input
            type="text"
            class="form-control"
            id="name"
            formControlName="name"
            [class.is-invalid]="hasValidationError(nameCtl)"
            placeholder="Enter department name"
          />
          <div class="invalid-feedback" *ngIf="hasValidationError(nameCtl)">
            {{ getValidationMessage(nameCtl) }}
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label for="description">Description</label>
          <textarea
            class="form-control"
            id="description"
            formControlName="description"
            rows="3"
            [class.is-invalid]="hasValidationError(descriptionCtl)"
            placeholder="Enter department description"
          ></textarea>
          <div
            class="invalid-feedback"
            *ngIf="hasValidationError(descriptionCtl)"
          >
            {{ getValidationMessage(descriptionCtl) }}
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label for="headerText">Header Text</label>
          <input
            type="text"
            class="form-control"
            id="headerText"
            formControlName="headerText"
            [class.is-invalid]="hasValidationError(headerTextCtl)"
            placeholder="Enter header text for department page"
          />
          <div
            class="invalid-feedback"
            *ngIf="hasValidationError(headerTextCtl)"
          >
            {{ getValidationMessage(headerTextCtl) }}
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="iconUrl">Department Icon</label>
          <select
            class="form-control icon-select"
            id="iconUrl"
            formControlName="iconUrl"
            [class.is-invalid]="hasValidationError(iconUrlCtl)"
          >
            <option *ngFor="let option of iconOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="hasValidationError(iconUrlCtl)">
            {{ getValidationMessage(iconUrlCtl) }}
          </div>
          <div class="mt-2">
            <small class="text-muted">Preview: </small>
            <span class="material-icons" *ngIf="iconUrlCtl.value">{{ iconUrlCtl.value }}</span>
            <span class="text-muted" *ngIf="!iconUrlCtl.value"
              >No icon selected</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="requireDocumentReview"
              formControlName="requireDocumentReview"
            />
            <label class="form-check-label" for="requireDocumentReview">
              Require Document Review
            </label>
            <small class="form-text text-muted d-block">
              When enabled, documents uploaded to workflow applications in this department
              without a specific data entity will require staff review by default.
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="department && departmentId && departmentId !== 'add' && department.id">
      <div class="col-12">
        <div class="card mt-3">
          <div class="card-header">
            <h6 class="mb-0">Applications Grid Dataset</h6>
          </div>
          <div class="card-body">
            <wm-dataset-designer
              [dataSetId]="(department?.applicationGridDataSetId || Utilities.EMPTY_GUID)"
              [dataSetName]="department?.name + ' Applications'"
              [showNewDatasetControls]="false"
              [showDataSetInformation]="false"
              [showFilterInputConfiguration]="false"
              [showSortingConfiguration]="false"
              [staticFilters]="getStaticFiltersForDepartment()"
              [getAvailableWorkflows]="getWorkflowsForDepartment"
              [staticFields]="getStaticFieldsForDepartment()"
              (dataSetSaved)="onDataSetSaved($event)">
            </wm-dataset-designer>

            <!-- Testing Controls - Only visible in dev environment for system admins -->
            <div *ngIf="showTestingControls$ | async">
              <!-- Temporary Test Button -->
              <div class="mt-3">
                <button
                  type="button"
                  class="btn btn-info"
                  (click)="testGetDepartmentApplications()"
                  [disabled]="testingApi">
                  <span *ngIf="testingApi" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ testingApi ? 'Testing...' : 'Test Get Department Applications API' }}
                </button>
              </div>

              <!-- Column Selection -->
              <div class="mt-3">
                <h6 class="mb-2">Select Columns to Return:</h6>
                <div class="card">
                  <div class="card-body">
                    <div *ngIf="availableColumns.length === 0" class="alert alert-info mb-0">
                      <i class="fas fa-info-circle me-2"></i>
                      <strong>No columns available.</strong> Please configure the Applications Grid Dataset above first.
                    </div>
                    <div *ngIf="availableColumns.length > 0">
                      <div class="mb-2">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="selectAllColumns"
                            [(ngModel)]="selectAllColumns"
                            [ngModelOptions]="{standalone: true}"
                            (change)="toggleAllColumns()" />
                          <label class="form-check-label fw-bold" for="selectAllColumns">
                            Select All Columns ({{ selectedColumns.length }} of {{ availableColumns.length }} selected)
                          </label>
                        </div>
                        <small class="text-muted d-block mt-1">
                          <i class="fas fa-info-circle me-1"></i>
                          Selecting specific columns will reduce the data returned from the API call.
                          If all columns are selected, no column filtering is applied.
                        </small>
                      </div>
                      <hr class="my-2" />
                      <div class="row">
                        <div class="col-md-3 col-sm-6" *ngFor="let column of availableColumns">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [id]="'col_' + column.name"
                              [checked]="isColumnSelected(column.name)"
                              (change)="toggleColumnSelection(column.name)" />
                            <label class="form-check-label" [for]="'col_' + column.name">
                              {{ column.label }}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="mt-2" *ngIf="!selectAllColumns && selectedColumns.length > 0">
                        <small class="text-info">
                          <i class="fas fa-filter me-1"></i>
                          API will return only these {{ selectedColumns.length }} column(s):
                          <strong>{{ selectedColumns.join(', ') }}</strong>
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Simple Search Test -->
              <div class="mt-3">
                <h6 class="mb-2">Test Simple Search (All Fields):</h6>
                <div class="card">
                  <div class="card-body">
                    <div class="row g-3 align-items-end">
                      <div class="col-md-8">
                        <label for="simpleSearchValue" class="form-label">Search Value</label>
                        <input
                          type="text"
                          id="simpleSearchValue"
                          class="form-control"
                          [(ngModel)]="simpleSearchValue"
                          [ngModelOptions]="{standalone: true}"
                          placeholder="Enter value to search across all fields..."
                          [disabled]="testingSimpleSearch"
                          (keyup.enter)="testSimpleSearch()" />
                        <small class="text-muted">This will search for the value across all available fields in the dataset.</small>
                      </div>
                      <div class="col-md-4">
                        <button
                          type="button"
                          class="btn btn-success w-100"
                          (click)="testSimpleSearch()"
                          [disabled]="testingSimpleSearch || !simpleSearchValue">
                          <span *ngIf="testingSimpleSearch" class="spinner-border spinner-border-sm me-1" role="status"></span>
                          {{ testingSimpleSearch ? 'Searching...' : 'Search All Fields' }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Sorting Test Buttons -->
              <div class="mt-3">
                <h6 class="mb-2">Test Column Sorting:</h6>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>Column</th>
                        <th class="text-center">Sort Ascending</th>
                        <th class="text-center">Sort Descending</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let column of sortableColumns">
                        <td>{{ column.label }}</td>
                        <td class="text-center">
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-success"
                            (click)="testSorting(column.name, false)"
                            [disabled]="testingSortField">
                            <span *ngIf="testingSortField === column.name + '_ASC'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                            <i class="fas fa-arrow-up" *ngIf="testingSortField !== column.name + '_ASC'"></i>
                            {{ testingSortField === column.name + '_ASC' ? 'Testing...' : 'ASC' }}
                          </button>
                        </td>
                        <td class="text-center">
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-danger"
                            (click)="testSorting(column.name, true)"
                            [disabled]="testingSortField">
                            <span *ngIf="testingSortField === column.name + '_DESC'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                            <i class="fas fa-arrow-down" *ngIf="testingSortField !== column.name + '_DESC'"></i>
                            {{ testingSortField === column.name + '_DESC' ? 'Testing...' : 'DESC' }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Filter Test Buttons -->
              <div class="mt-3">
                <h6 class="mb-2">Test New Filters:</h6>
                <div class="d-flex flex-wrap gap-2">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="testFilter('REQUIRED_DOCUMENTS')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'REQUIRED_DOCUMENTS'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Required Docs
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="testFilter('GENERATED_PERMITS')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'GENERATED_PERMITS'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Generated Permits
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="testFilter('REGISTRATIONS_TO_RENEW')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'REGISTRATIONS_TO_RENEW'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Registrations to Renew
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="testFilter('INSPECTIONS')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'INSPECTIONS'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Inspections
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="testFilter('INSPECTIONS_TO_SCHEDULE')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'INSPECTIONS_TO_SCHEDULE'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Insp. To Schedule
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="testFilter('INSPECTIONS_TO_COMPLETE')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'INSPECTIONS_TO_COMPLETE'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Insp. To Complete
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="testFilter('UPCOMING_INSPECTIONS_TO_COMPLETE')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'UPCOMING_INSPECTIONS_TO_COMPLETE'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Upcoming Insp.
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="testFilter('REGISTRATIONS_ABOUT_TO_EXPIRE')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'REGISTRATIONS_ABOUT_TO_EXPIRE'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Reg. About to Expire
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="testFilter('PENDING_PAYMENTS')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'PENDING_PAYMENTS'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Pending Payments
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-info"
                  (click)="testFilter('MY_APPLICATIONS')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'MY_APPLICATIONS'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  My Applications
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-success"
                  (click)="testFilter('SHARED_BY_ME')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'SHARED_BY_ME'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Shared By Me
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-success"
                  (click)="testFilter('SHARED_WITH_ME')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'SHARED_WITH_ME'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Shared With Me
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-warning"
                  (click)="testFilter('RELEVANT_TO_USER')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'RELEVANT_TO_USER'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Relevant To User
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  (click)="testFilter('NEEDS_MY_ATTENTION')"
                  [disabled]="testingFilter">
                  <span *ngIf="testingFilter === 'NEEDS_MY_ATTENTION'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Needs My Attention
                </button>
              </div>
            </div>

            <!-- Custom Field Filter Test -->
            <div class="mt-3">
              <h6 class="mb-2">Test Custom Field Filter:</h6>
              <div class="card">
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-md-4">
                      <label for="customFilterField" class="form-label">Select Field</label>
                      <select
                        id="customFilterField"
                        class="form-select form-select-sm"
                        [(ngModel)]="customFilterField"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="testingCustomFilter">
                        <option value="">-- Choose a field --</option>
                        <option *ngFor="let field of availableFilterFields" [value]="field.name">
                          {{ field.name || field.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label for="customFilterOperator" class="form-label">Operator</label>
                      <select
                        id="customFilterOperator"
                        class="form-select form-select-sm"
                        [(ngModel)]="customFilterOperator"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="testingCustomFilter">
                        <option *ngFor="let op of filterOperators" [value]="op.value">
                          {{ op.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label for="customFilterValue" class="form-label">Filter Value</label>
                      <input
                        type="text"
                        id="customFilterValue"
                        class="form-control form-control-sm"
                        [(ngModel)]="customFilterValue"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="Enter value..."
                        [disabled]="testingCustomFilter"
                        (keyup.enter)="testCustomFieldFilter()" />
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">&nbsp;</label>
                      <button
                        type="button"
                        class="btn btn-primary btn-sm w-100"
                        (click)="testCustomFieldFilter()"
                        [disabled]="testingCustomFilter || !customFilterField || !customFilterValue">
                        <span *ngIf="testingCustomFilter" class="spinner-border spinner-border-sm me-1" role="status"></span>
                        {{ testingCustomFilter ? 'Testing...' : 'Apply Filter' }}
                      </button>
                    </div>
                  </div>
                  <div class="mt-2">
                    <small class="text-muted">
                      <i class="fas fa-info-circle me-1"></i>
                      Select a field, choose an operator, enter a value, and click "Apply Filter" to test custom filtering.
                    </small>
                  </div>
                </div>
              </div>
            </div>
            </div>
            <!-- End Testing Controls -->

            <!-- Test Results Grid -->
            <div class="mt-4" *ngIf="testResults && testResultColumns.length > 0">
              <div class="card">
                <div class="card-header bg-info text-white d-flex justify-content-between align-items-center">
                  <div>
                    <h6 class="mb-0">
                      <i class="fas fa-table me-2"></i>API Test Results
                      <span class="badge bg-light text-dark ms-2">{{ testResultRows.length }} rows</span>
                      <span class="badge bg-warning text-dark ms-1" *ngIf="Object.keys(gridFilters).length > 0">
                        {{ Object.keys(gridFilters).length }} filter(s) active
                      </span>
                    </h6>
                    <small class="d-block mt-1" *ngIf="lastTestDescription">{{ lastTestDescription }}</small>
                  </div>
                  <div class="d-flex gap-2">
                    <button
                      type="button"
                      class="btn btn-sm btn-warning"
                      (click)="clearGridFilters()"
                      *ngIf="Object.keys(gridFilters).length > 0"
                      title="Clear all filters">
                      <i class="fas fa-filter-circle-xmark"></i> Clear Filters
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-light"
                      (click)="clearTestResults()"
                      title="Clear results">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive" style="max-height: 600px; overflow: auto;">
                    <table class="table table-sm table-bordered table-hover mb-0">
                      <thead class="table-light sticky-top">
                        <tr>
                          <th class="text-center" style="width: 40px;">#</th>
                          <th *ngFor="let column of testResultColumns" class="text-nowrap" style="cursor: pointer; user-select: none;">
                            <div (click)="sortGridByColumn(column.resultHeader)" class="d-flex justify-content-between align-items-center">
                              <span>{{ column.name }}</span>
                              <i [class]="getSortIcon(column.resultHeader)" class="ms-1"></i>
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <th class="text-center"></th>
                          <th *ngFor="let column of testResultColumns" class="p-1">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              [placeholder]="'Filter ' + column.name"
                              [value]="gridFilters[column.resultHeader] || ''"
                              (input)="onGridFilterChange(column.resultHeader, $any($event.target).value)"
                              (click)="$event.stopPropagation()" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of testResultRows; let i = index">
                          <td class="text-center text-muted">{{ i + 1 }}</td>
                          <td *ngFor="let column of testResultColumns" [title]="getCellValue(row, column.resultHeader)">
                            {{ getCellValue(row, column.resultHeader) }}
                          </td>
                        </tr>
                        <tr *ngIf="testResultRows.length === 0">
                          <td [attr.colspan]="testResultColumns.length + 1" class="text-center text-muted py-4">
                            <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                            No results returned from API
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="card-footer text-muted small">
                  <i class="fas fa-info-circle me-1"></i>
                  Results are also logged to the browser console for detailed inspection.
                </div>
              </div>
            </div>
            <!-- End Test Results Grid -->
             
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="showControls">
      <div class="col">
        <div class="form-group">
          <button
            type="button"
            (click)="save()"
            class="btn btn-primary"
            [disabled]="saving || form.invalid"
          >
            <span
              *ngIf="saving"
              class="spinner-border spinner-border-sm"
              role="status"
            ></span>
            {{
              saving
                ? 'Saving...'
                : departmentId === 'add'
                ? 'Create Department'
                : 'Update Department'
            }}
          </button>
          <button
            type="button"
            class="btn btn-secondary ms-2"
            (click)="cancel()"
            [disabled]="saving"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger ms-2"
            (click)="delete()"
            *ngIf="departmentId && departmentId !== 'add'"
            [disabled]="saving"
          >
            Delete
          </button>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="departmentId && departmentId !== 'add' && canConfigureInspectionApp">
      <div class="col">
        <a
          [routerLink]="['inspection-app-columns']"
          class="btn btn-info"
        >
          Configure Inspection App Columns
        </a>
      </div>
    </div>

    <div class="row" *ngIf="showGoBackToList">
      <div class="col">
        <a
          href="#"
          (click)="goBackToList(); $event.preventDefault()"
          class="btn btn-link"
        >
          ← Back to Department List
        </a>
      </div>
    </div>
  </form>
</div>

<div class="text-center" *ngIf="loading">
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
